export default __webpack_public_path__ + "static/media/Flag_of_the_United_Kingdom.b900c9a5.svg";